/**
 * Utility function to generate correct asset paths for both development and production (CDN)
 * Reads the CDN URL from the HTML document element's cdn-url attribute (set at runtime)
 * or falls back to the configured UI URL
 */

import { getCdnUrl, isDevelopment } from '../services/environment'

/**
 * Get the full path to an asset, accounting for CDN URL
 * @param path - The asset path relative to the CDN root (without leading slash)
 * @example getAssetPath('assets/images/logo.svg') -> '/assets/images/logo.svg' (dev) or 'https://cdn.example.com/path/assets/images/logo.svg' (prod)
 */
export function getAssetPath(path: string): string {
  // In development, use root-relative paths (served by Vite dev server)
  if (isDevelopment()) {
    const cleanPath = path.startsWith('/') ? path : `/${path}`
    return cleanPath
  }

  // In production, use full CDN URL
  const cdnUrl = getCdnUrl()
  // Remove leading slash from path if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path

  // If CDN URL already ends with /, don't add another one
  const separator = cdnUrl.endsWith('/') ? '' : '/'

  return `${cdnUrl}${separator}${cleanPath}`
}
